var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagePrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83931 2.06658V1.03131C8.83931 0.941578 8.73619 0.892024 8.66655 0.946935L2.62905 5.66256C2.57775 5.70245 2.53624 5.75353 2.50769 5.81191C2.47914 5.87028 2.46429 5.93441 2.46429 5.99939C2.46429 6.06437 2.47914 6.1285 2.50769 6.18687C2.53624 6.24525 2.57775 6.29633 2.62905 6.33622L8.66655 11.0518C8.73753 11.1068 8.83931 11.0572 8.83931 10.9675V9.9322C8.83931 9.86658 8.80851 9.80363 8.75762 9.76345L3.93619 6.00006L8.75762 2.23533C8.80851 2.19515 8.83931 2.1322 8.83931 2.06658Z",
    fill: "#C6CBD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagePrev);
export default __webpack_public_path__ + "static/media/pagePrev.c472669511a489ddccb780956afd05f6.svg";
export { ForwardRef as ReactComponent };